import axios from "axios";

export const getSettings = () =>
  axios({ method: "GET", url: "/api/v1/settings" });
